module.exports = __webpack_public_path__ + "img/1518307636.851d5390.jpg";